var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.prefix__st0 {\n\t\t\tfill: #414141\n\t\t}\n\n\t\t.prefix__st1 {\n\t\t\tfill-rule: evenodd;\n\t\t\tclip-rule: evenodd;\n\t\t\tfill: none;\n\t\t\tstroke: #414141;\n\t\t\tstroke-miterlimit: 10\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M23 6.9V19H12.6V6.9H23m1-1H11.6V20H24V5.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st1",
    d: "M12 9.9h11.6M12 12.9h11.6M12 15.9h11.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M11.4 3.1V21H1V3.1h10.4m1-1H0V22h12.4V2.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M8.4 15.8v5.1H4v-5.1h4.4m1-1H3v7.1h6.4v-7.1zM8.4 10.6v.2H4v-.2h4.4m1-1H3v2.2h6.4V9.6zM8.4 6.4v.2H4v-.2h4.4m1-1H3v2.2h6.4V5.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessProperty);
export default __webpack_public_path__ + "static/media/business-property.3a11cacee93f4f60b9b4c7f57c515e95.svg";
export { ForwardRef as ReactComponent };